import { SidebarMenuSub } from '@/app/_components/ui/sidebar';
import { SidebarMenuSubItemLink } from './sidebar-menu-sub-item-link';
import { LucideIcon } from 'lucide-react';

interface SubMenuItem {
  title: string;
  href: string;
  icon: LucideIcon;
}

interface SidebarMenuSubListProps {
  items: SubMenuItem[];
  pathname: string;
  isMobile: boolean;
  openMobile: boolean;
  setOpenMobile: (open: boolean) => void;
  className?: string;
}

export function SidebarMenuSubList({
  items,
  pathname,
  isMobile,
  openMobile,
  setOpenMobile,
  className = 'flex flex-col gap-1 mt-2 ml-2',
}: SidebarMenuSubListProps) {
  return (
    <SidebarMenuSub className={className}>
      {items.map((item) => (
        <SidebarMenuSubItemLink
          key={item.title}
          title={item.title}
          href={item.href}
          icon={item.icon}
          pathname={pathname}
          isMobile={isMobile}
          openMobile={openMobile}
          setOpenMobile={setOpenMobile}
        />
      ))}
    </SidebarMenuSub>
  );
}
